import React from 'react';
import PropTypes from 'prop-types';

import { Dialog } from '@mui/material';
import Content from './Content/Content';
import Actions from './Actions';
import DialogTitle from 'ui/DialogTitle';

const ElementModal = ({ open, onClose, onSubmit, pageElement, onChange }) => {

  const { element_type, content, id } = pageElement;

  const title = id ? "Edit Social Link" : "Add Social Link";
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth 
      maxWidth="md"
    > 
      <DialogTitle title={title} onClose={onClose} />

      <Content
        pageElementId={id}
        elementType={element_type}
        content={content}
        onChange={onChange}
      />

      <Actions
        onSubmit={onSubmit}
        onClose={onClose}
        pageElementId={id}
      />

    </Dialog>
  );
};

ElementModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  pageElement: PropTypes.object,
  onChange: PropTypes.func,
};

export default ElementModal;